import { frontendURL } from '../../../helper/URLHelper';
import VisitasIndex from './pages/VisitasIndex.vue';
import VisitaDetail from './pages/VisitaDetail.vue';
import VisitaForm from './pages/VisitaForm.vue';
import VisitaFinish from './pages/VisitaFinish.vue';
import VisitaReview from './pages/VisitaReview.vue';
import VisitaSuccess from './pages/VisitaSuccess.vue';
import VisitorInfoPage from './pages/VisitorInfoPage.vue';
import VisitDeepLinkRedirect from './pages/VisitDeepLinkRedirect.vue';
import OpenHouseIndex from './pages/OpenHouseIndex.vue';
import OpenHouseShow from './pages/OpenHouseShow.vue';
import { LAIS_VISITAS_PERMISSIONS } from '../laisRouteHelpers';

const meta = { permissions: LAIS_VISITAS_PERMISSIONS };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/open-house'),
    alias: [
      frontendURL('accounts/:accountId/visitas/open-house'),
      frontendURL('accounts/:accountId/open-house/eventos'),
    ],
    name: 'open_house_index',
    component: OpenHouseIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/open-house/:id'),
    name: 'open_house_show',
    component: OpenHouseShow,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas'),
    alias: [
      frontendURL('accounts/:accountId/visits'),
      frontendURL('accounts/:accountId/visit'),
      frontendURL('accounts/:accountId/agenda'),
      frontendURL('accounts/:accountId/agenda/disponibilidade'),
      frontendURL('accounts/:accountId/agenda/bloqueios'),
      frontendURL('accounts/:accountId/chaves'),
      frontendURL('accounts/:accountId/chaves/entrada'),
      frontendURL('accounts/:accountId/chaves/retirar/:imovelId'),
      frontendURL('accounts/:accountId/keys'),
      frontendURL('accounts/:accountId/visitas/proximas'),
      frontendURL('accounts/:accountId/visitas/clientes-agendados'),
      frontendURL('accounts/:accountId/visitas/clientes-com-visita-agendada'),
      frontendURL('accounts/:accountId/visitas-agendadas'),
      frontendURL('accounts/:accountId/visitas/pendentes'),
      frontendURL('accounts/:accountId/visitas/a-finalizar'),
      frontendURL('accounts/:accountId/visitas/passadas'),
      frontendURL('accounts/:accountId/visitas/canceladas'),
      frontendURL('accounts/:accountId/visitas/agendar'),
    ],
    name: 'visitas_index',
    component: VisitasIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/new'),
    name: 'visita_new',
    component: VisitaForm,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/codigo/:visitCode'),
    name: 'visita_deep_link',
    component: VisitDeepLinkRedirect,
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/visitas/codigo/:visitCode/finalizar/:result?'
    ),
    name: 'visita_deep_link_finish',
    component: VisitDeepLinkRedirect,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/codigo/:visitCode/cancelar'),
    name: 'visita_deep_link_cancel',
    component: VisitDeepLinkRedirect,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/codigo/:visitCode/remarcar'),
    name: 'visita_deep_link_reschedule',
    component: VisitDeepLinkRedirect,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/:id/sucesso'),
    name: 'visita_success',
    component: VisitaSuccess,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/:id/finalizar'),
    name: 'visita_finish',
    component: VisitaFinish,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/visitante/:visitorId'),
    alias: [
      frontendURL('accounts/:accountId/visitas/visitor/:visitorId'),
      frontendURL('accounts/:accountId/visitas/leads/:visitorId/visita'),
    ],
    name: 'visitor_info',
    component: VisitorInfoPage,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/:id'),
    name: 'visita_show',
    component: VisitaDetail,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/:id/revisar'),
    name: 'visita_review',
    component: VisitaReview,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/visitas/:id/edit'),
    name: 'visita_edit',
    component: VisitaForm,
    meta,
  },
];
